<template>
  <div v-loading="loading">
    <!-- <div class="el-card__header card-header__wrap">
      <span class="card-header--title"></span>
      <div class="card-header--form">
        <date-range-select
          v-model="daterange"
          :callback="()=>handleCurrentChange(1)" />
        <order-source-select
          v-model="config.source"
          style="margin-left:10px"
          :callback="()=>handleCurrentChange(1)" />
        <out-status-select
          v-model="config.outStatus"
          style="margin-left:10px"
          :callback="()=>handleCurrentChange(1)" />
        <out-type-select
          v-model="config.outType"
          style="margin-left:10px"
          :callback="()=>handleCurrentChange(1)" />
        <el-input
          v-model.trim="config.receiverName"
          clearable=""
          placeholder="请输入收件人姓名"
          style="width: 160px;margin-left:10px">
        </el-input>
        <el-input
          v-model="config.code"
          clearable=""
          placeholder="请输入订单号"
          style="width: 180px;margin-left:10px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </div>
    </div> -->
    <el-form
      label-width="80px"
      @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="交易时间:">
            <date-range-select
              v-model="daterange"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单来源:">
            <order-source-select
              v-model="config.source"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单状态:">
            <order-status-select
              v-model="config.status"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发货状态:">
            <out-status-select
              v-model="config.outStatus"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发货方式:">
            <out-type-select-new
              v-model="config.outTypeNew"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收件人:">
            <el-input
              v-model.trim="config.receiverName"
              clearable=""
              placeholder="请输入收件人姓名">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单号:">
            <el-input
              v-model.trim="config.code"
              clearable=""
              placeholder="请输入订单号">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售部门:">
            <el-input
              v-model.trim="config.saleDepartmentName"
              clearable=""
              placeholder="请输入销售部门">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售人员:">
            <el-input
              v-model.trim="config.saleStaffName"
              clearable=""
              placeholder="请输入销售人员">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注:">
            <el-input
              v-model.trim="config.remark"
              clearable=""
              placeholder="请输入备注">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="">
            <el-button
              type="primary"
              @click="handleCurrentChange(1)">查询</el-button>
            <el-button
              type="success"
              @click="downloadOrders">导出订单</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      border
      :data="list">
      <el-table-column
        label="订单号"
        fixed="left"
        :resizable="false"
        width="170">
        <template slot-scope="{row}">
          <link-route :link-to="`/orders-detail?vendorId=${row.parentOwnerCode}&salesOrderId=${row.id}&code=${row.code}`">
            {{ row.code }}
          </link-route>
        </template>
      </el-table-column>
      <el-table-column
        label="收件人"
        min-width="200"
        :resizable="false">
        <template slot-scope="{row}">
          <div>
            <span v-if="row.customerName">{{ row.customerName }}-</span>
            <span>{{ row.receiverName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单金额"
        width="100"
        :resizable="false">
        <template slot-scope="{row}">
          <div>¥{{ row.totalAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单来源"
        width="100"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.source | sourceName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单状态"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.status | orderStatusName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="发货状态"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.outStatus | orderOutStatusName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="发货方式"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          <!-- {{ row.outType | orderOutTypeName() }} <span v-if="row.orderFlag && row.orderFlag!=='0'">({{ row.orderFlag | orderTagName() }})</span> -->
          <span v-if="row.outType === 0">待定</span>
          <span v-if="row.outType === 1 && row.orderFlag === '1'">正常发货</span>
          <span v-if="row.outType === 1 && row.orderFlag === '2'">改单发货</span>
          <span v-if="row.outType === 2 && row.orderFlag === '3'">空包发货</span>
          <span v-if="row.outType === 1 && row.orderFlag === '3'">刷单发货</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        min-width="180"
        prop="remark"
        :resizable="false">
      </el-table-column>
      <!-- <el-table-column
        label="物流方式"
        width="70"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.transType | transTypeName() }}
        </template>
      </el-table-column> -->
      <el-table-column
        label="交易时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}">
          {{ row.tradeTime | dateformat( ) }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="edit"
        label="操作"
        fixed="right"
        :resizable="false"
        width="240">
        <template slot-scope="{row}">
          <el-button
            type="primary"
            :disabled="!(row.outType === 0 && row.status === 0 && row.outStatus === 0)"
            @click.native="check(row)">审单</el-button>
          <el-button
            type="success"
            :disabled="!(row.outType > 0 && [0, 1].indexOf(row.outStatus) > -1 && [0, 1].indexOf(row.status) > -1 && row.outNum < row.planNum)"
            @click.native="addout(row)">建单</el-button>
          <!-- <el-button
            type="text"
            :disabled="!(row.outStatus === 0 && row.source === 9)"
            @click.native="salescancel(row)">删除</el-button>
          <el-button
            type="text"
            :disabled="!(row.outType > 0 && row.outStatus === 0)"
            @click.native="deaudit(row)">反审</el-button>
          <el-button
            type="text"
            :disabled="!(row.outType > 0 && row.source === 9 && row.outStatus > 0)"
            @click.native="salesfinish(row)">强制关闭</el-button> -->
          <el-dropdown>
            <el-button
              type="info"
              style="margin-left: 10px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="!(row.outStatus === 0 && row.source === 9)"
                @click.native="salescancel(row)">删除</el-dropdown-item>
              <el-dropdown-item
                :disabled="!(row.outType > 0 && row.outStatus === 0)"
                @click.native="deaudit(row)">反审</el-dropdown-item>
              <el-dropdown-item
                :disabled="!(row.outType > 0 && [0, 1].indexOf(row.outStatus) > -1 && [0,1].indexOf(row.status) > -1)"
                @click.native="salesfinish(row, false)">强制关闭</el-dropdown-item>
              <el-dropdown-item
                :disabled="!(row.outType > 0 && [0, 1].indexOf(row.outStatus) > -1 && [0,1].indexOf(row.status) > -1)"
                @click.native="salesfinish(row, true)">无码出库</el-dropdown-item>
              <el-dropdown-item
                @click.native="editremark(row)">修改备注</el-dropdown-item>
              <el-dropdown-item
                :disabled="!([1,2,6].indexOf(row.source) > -1 && row.status === 2)"
                @click.native="copy(row)">复制订单</el-dropdown-item>
              <!--  :disabled="!(row.outType > 0 && row.source === 9 && row.outStatus > 0)" -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-dropdown>
            <el-button type="info">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="row.outType === 0 && row.status === 0 && row.outStatus === 0"
                @click.native="check(row)">审单</el-dropdown-item>

              <el-dropdown-item
                v-if="row.outStatus === 0 && row.source === 9"
                @click.native="salescancel(row)">删除</el-dropdown-item>

              <el-dropdown-item
                v-if="row.outType > 0 && row.outStatus === 0"
                @click.native="deaudit(row)">反审</el-dropdown-item>

              <template v-if="row.outType > 0 && [0, 1].indexOf(row.outStatus) > -1 && [0, 1].indexOf(row.status) > -1">
                <el-dropdown-item
                  :disabled="!(row.outNum < row.planNum)"
                  @click.native="addout(row)">建单</el-dropdown-item>
              </template>

              <el-dropdown-item
                v-if="row.outType > 0 && row.source === 9 && row.outStatus > 0"
                @click.native="salesfinish(row)">强制关闭</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-dropdown-item
                v-if="row.outType > 0 && row.outStatus === 0 && row.source === 9 && [0, 1].indexOf(row.status) > -1"
                @click.native="salescancel(row)">删除</el-dropdown-item> -->

          <!-- row.outType > 0 && row.source === 9 && [0, 1].indexOf(row.status) > -1  && row.outStatus === 1 -->
          <!--
          <template v-if="row.outType === 0 && row.status === 0 && row.outStatus === 0">
            <el-button
              type="warning"
              @click.native="check(row)">
              审单
            </el-button>
            <el-button
              v-if="row.source === 9"
              type="danger"
              @click.native="salescancel(row)">
              删除
            </el-button>
          </template>
          <el-button
            v-if="row.outType > 0 && row.outStatus === 0"
            type="warning"
            @click.native="deaudit(row)">
            反审
          </el-button> -->
          <!-- <template v-if="[1, 2, 3].indexOf(row.outType) > -1 && [0, 1].indexOf(row.outStatus)> -1 && [0, 1].indexOf(row.status) > -1">
            <el-button
              v-if="row.outNum < row.planNum"
              type="primary"
              @click.native="addout(row)">
              建单
            </el-button>
            <el-button
              v-if="row.source === 9 && row.outStatus === 0"
              type="danger"
              @click.native="salescancel(row)">
              删除
            </el-button>
            <el-button
              v-if="row.source === 9 && row.outStatus > 0"
              type="info"
              @click.native="salesfinish(row)">
              强制关闭
            </el-button>
          </template> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <order-audit-modal
      ref="audit"
      :callback="fetchList" />
    <order-out-modal
      ref="out"
      :callback="fetchList" />
    <!-- <order-extra-modal ref="extra" /> -->
    <order-remark-modal
      ref="remark"
      :callback="fetchList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OrderAuditModal from './busi/order-audit-modal.vue'
import OrderOutModal from './busi/order-out-modal.vue'
import NP from 'number-precision'
import OutTypeSelectNew from './out-type-select-new.vue'
import OutStatusSelect from './out-status-select.vue'
import OrderSourceSelect from './order-source-select.vue'
import DateRangeSelect from './date-range-select.vue'
import moment from 'moment'
import OrderRemarkModal from './busi/order-remark-modal.vue'
import OrderStatusSelect from './order-status-select.vue'

// import OrderExtraModal from './busi/order-extra-modal.vue'
export default {
  name: 'OrderTableAll',
  components: { OrderStatusSelect, OrderRemarkModal, OrderAuditModal, OrderOutModal, OutTypeSelectNew, OutStatusSelect, OrderSourceSelect, DateRangeSelect },
  props: {
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        status: null,
        receiverName: null,
        outTypeNew: null,
        outStatus: null,
        source: null,
        saleDepartmentName: null,
        saleStaffName: null,
        remark: ''
      },
      daterange: null,
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    copy(row) {
      this.$router.push(`/orders-create?salesOrderId=${row.id}&departmentId=${row.ownerCode}`)
    },
    downloadOrders() {
      this.loading = true
      const [tradeTimeStart, tradeTimeEnd] = this.daterange || [null, null]
      const [outType, orderFlag] = (this.config.outTypeNew || '-').split('-')
      this.$store.dispatch('outstock/downloadorders', {
        payload: {
          ...this.config,
          outType: outType || null,
          orderFlag: orderFlag || null,
          receiverName: this.config.receiverName || null,
          tradeTimeStart: +moment(tradeTimeStart).startOf('days'),
          tradeTimeEnd: +moment(tradeTimeEnd).endOf('days')
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    editremark(row) {
      this.$refs.remark.fetch({
        salesOrderId: row.id,
        remark: row.remark,
        code: row.code
      })
    },
    deaudit(row) {
      this.$confirm('此操作将回退该订单到重新审核状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/deaudit', {
            payload: {
              salesOrderId: row.id
            },
            success: () => {
              this.loading = false
              // this.$refs.table.clearSelection()
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    salescancel(row) {
      this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/salesdelete', {
            payload: {
              code: row.code
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    salesfinish(row, forcedDelivery) {
      this.$confirm(`此操作将对该订单进行${forcedDelivery ? '无码出库' : '强制关闭'}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/salesfinish', {
            payload: {
              code: row.code,
              forcedDelivery
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    check(row) {
      this.$refs.audit.fetch(row.id)
    },
    addout(row) {
      this.$refs.out.fetch(row.id)
    },
    // addextraout(row) {
    //   this.$refs.extra.fetch(row.id)
    // },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const [tradeTimeStart, tradeTimeEnd] = this.daterange || [null, null]
      const [outType, orderFlag] = (this.config.outTypeNew || '-').split('-')
      this.$store.dispatch('outstock/getsaleslist', {
        payload: {
          ...this.config,
          outType: outType || null,
          orderFlag: orderFlag || null,
          receiverName: this.config.receiverName || null,
          tradeTimeStart: +moment(tradeTimeStart).startOf('days'),
          tradeTimeEnd: +moment(tradeTimeEnd).endOf('days')
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records.map(i => ({
            ...i,
            totalAmount: NP.divide(i.totalAmount, 100),
            itemAmount: NP.divide(i.itemAmount, 100),
            discountAmount: NP.divide(i.discountAmount, 100)
          }))
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
